/* @ngInject */
function DragAndDropController ($rootScope, $scope, $timeout, $attrs) {
  $scope.disableAnimation = false
  $scope.dragAndDropEvent = ''
  $scope.isUploading = false
  const mainContent = $scope.mainContent
  let dropZone = null

  const api = {
    _setDropZone,
    _checkDragEvent,
    _onDrop,
    _handleFileDrop
  }

  this.getApi = () => api

  function activate () {
    $timeout(() => {
      api._setDropZone()
    }, 1000)
  }

  activate()

  const deregisterDragAndDropLoader = $rootScope.$on('drag-and-drop.stop-loader', (event) => {
    $scope.isUploading = false
  })

  function _setDropZone () {
    dropZone = $attrs.$$element.find(`#dropZone-${$scope.collection.id}`)[0]
    mainContent.addEventListener('dragover', api._checkDragEvent, false)
    mainContent.addEventListener('dragleave', api._checkDragEvent, false)
    dropZone.addEventListener('drop', api._onDrop, false)
  }

  function _checkDragEvent (event) {
    event.stopPropagation()
    event.preventDefault()

    if (event.type === 'dragleave' && event.currentTarget?.contains(event.relatedTarget)) {
      return
    }

    $timeout(() => {
      if (event.type === 'dragover') {
        $scope.disableAnimation = true
        $scope.dragAndDropEvent = ''
        $scope.$emit('drag-and-drop.set-blur', true)
      }

      if (event.type === 'dragleave' || event.type === 'drop') {
        $scope.disableAnimation = false
        $scope.dragAndDropEvent = event.type
        $scope.$emit('drag-and-drop.set-blur', false)
      }
    })
  }

  function _onDrop (event) {
    api._checkDragEvent(event)
    const filesArray = Array.from(event.dataTransfer.files)
    api._handleFileDrop(filesArray)
  }

  $scope.$on('$destroy', function () {
    mainContent.removeEventListener('dragover', api._checkDragEvent)
    mainContent.removeEventListener('dragleave', api._checkDragEvent)
    dropZone.removeEventListener('drop', api._onDrop)
    deregisterDragAndDropLoader()
  })

  function _handleFileDrop (files) {
    $scope.isUploading = true
    $scope.onDrop(files, $scope.collection.id)
  }
}

export { DragAndDropController }
